export function valueOrNull<T>(value: T): T | null {
  return value === undefined ? null : value;
}

export function withoutNullOrEmptyValues<T extends {}>(object: T): any {
  const newValue = { ...object };
  Object.entries(newValue).forEach(([key, value]) => {
    if (value == null || (typeof value === 'string' && isNullOrWhitespace(value))) {
      delete (newValue as any)[key];
    }
  });
  return newValue;
}

export function getOrElse<T, TDefault>(
  value: T,
  defaultValue: TDefault,
): NonNullable<T> | TDefault {
  return value != null ? (value as NonNullable<T>) : defaultValue;
}

export function tryGet<T, R>(value: T, selector: (val: NonNullable<T>) => R): R | undefined {
  return value != null ? selector(value as NonNullable<T>) : undefined;
}

export function assertNotNull(value: any, name: string) {
  if (value == null) {
    throw new Error(`${name} cannot be null.`);
  }
}

export function parseBoolean(value: string | boolean | 1 | 0 | undefined): boolean {
  return value === 'true' || value === true || value === 1 ? true : false;
}

export function parseIntOrDefault(value: any, defaultValue: number): number {
  const parsed = tryParseInt(value);
  return parsed != null ? parsed : defaultValue;
}

export function tryParseInt(value: any): number | undefined {
  try {
    const parsed = parseInt(value, 10);
    if (!isNaN(parsed)) {
      return parsed;
    }
  } catch (err) {}
  return undefined;
}

export function assertNotNullOrWhitespace(value: string, name: string) {
  assertNotNull(value, name);
  if (value.trim() === '') {
    throw new Error(`${name} cannot be empty`);
  }
}

export function isNullOrWhitespace(value: string | undefined | null) {
  if (value == null) {
    return true;
  }
  if (value.trim() === '') {
    return true;
  }
  return false;
}

export function isEmail(email: string | null | undefined): boolean {
  if (email == null) {
    return false;
  }
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function isLetter(value: string) {
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < value.length; i++) {
    const char = value[i];
    if (char.toLowerCase() === char.toUpperCase()) {
      return false;
    }
  }
  return true;
}
